import { io, Socket } from "socket.io-client";

class HLBackendV1 {
    private static instances: { [key: string]: HLBackendV1 } = {};
    private socket: Socket;

   private constructor(namespace: string, token: string, query?: Record<string, any>) {
  const defaultUrl = process.env.WEBSOCKET_URL;
  this.socket = io(`${defaultUrl}${namespace}`, {
    transports: ["websocket", "polling"],
    auth: { token },
    query: query, // Pass query object here
    forceNew: true, // Forces a new connection for this namespace
    multiplex: false // Prevents reusing existing connections
  });
}

public static getInstance(namespace: string, token: string, query?: Record<string, any>): HLBackendV1 {
  // Create a unique key based on namespace and stringified query
  const queryKey = query ? JSON.stringify(query) : '';
  const instanceKey = `${namespace}:${queryKey}`;

  if (!HLBackendV1.instances[instanceKey]) {
    HLBackendV1.instances[instanceKey] = new HLBackendV1(namespace, token, query);
  }
  return HLBackendV1.instances[instanceKey];
}

    public getSocket(): Socket {
        return this.socket;
    }
}

export default HLBackendV1;



